import { createNgReactBridgeDirective } from '../../react-bridge'
import { TextOverflow } from '@contrast-security-inc/design-system-popovers'

export const reactTextOverflow = createNgReactBridgeDirective(
  'reactTextOverflow',
  [],
  TextOverflow,
  ['children', 'font', 'placement']
)
